module.exports = __webpack_public_path__ + "static/media/button-upload.9e5798ea.png";